import { type IntlShape } from "react-intl";
import { type z } from "zod";

import { type selectionValidationErrorSchema } from "@/schemas/routing/selection-validation";

export const getErrorMessage = (
	errorType: z.infer<typeof selectionValidationErrorSchema> | undefined,
	alias: string,
	intl: IntlShape,
) => {
	if (!errorType) {
		return intl.formatMessage({
			id: "Unknown",
			defaultMessage: "Unknown",
		});
	}

	switch (errorType) {
		case "AllowDistribution":
			return intl.formatMessage({
				id: "Distribution of work across machine groups is not enabled",
				defaultMessage: "Distribution of work across machine groups is not enabled",
			});

		case "BatchAlreadyProducing":
			return intl.formatMessage(
				{
					id: "{alias} is already producing",
					defaultMessage: "{alias} is already producing",
				},
				{ alias },
			);

		case "BatchNotFound":
			return intl.formatMessage(
				{
					id: "{alias} was not found",
					defaultMessage: "{alias} was not found",
				},
				{ alias },
			);

		case "CannotProduceBatch":
			return intl.formatMessage(
				{
					id: "cannot produce {alias}",
					defaultMessage: "cannot produce {alias}",
				},
				{ alias },
			);

		case "FilterByItemsThatCanBeProducedOnTheCurrentMachineGroup":
			return intl.formatMessage({
				id: "Cannot be produced by machine group",
				defaultMessage: "Cannot be produced by machine group",
			});

		case "FilterByLoadedMedia":
			return intl.formatMessage({
				id: "Required z-Fold not loaded",
				defaultMessage: "Required z-Fold not loaded",
			});

		case "FilterByMachine":
			return intl.formatMessage(
				{
					id: "{alias} is restricted to a different machine",
					defaultMessage: "{alias} is restricted to a different machine",
				},
				{ alias },
			);

		case "FilterByMachineGroup":
			return intl.formatMessage(
				{
					id: "{alias} is restricted to a different Machine Group",
					defaultMessage: "{alias} is restricted to a different Machine Group",
				},
				{ alias },
			);

		case "FilterByOptimalProduction":
			return intl.formatMessage(
				{
					id: "{alias} cannot be produced optimally by machine group",
					defaultMessage: "{alias} cannot be produced optimally by machine group",
				},
				{ alias },
			);

		case "FilterByPackStation":
			return intl.formatMessage(
				{
					id: "Packstation is not assigned for {alias}",
					defaultMessage: "Packstation is not assigned for {alias}",
				},
				{ alias },
			);

		case "FilterByStoppedCartonPropertyGroup":
			return intl.formatMessage({
				id: "Carton Property Group is stopped",
				defaultMessage: "Carton Property Group is stopped",
			});

		case "FilterByStoppedClassification":
			return intl.formatMessage({
				id: "Classification is stopped",
				defaultMessage: "Classification is stopped",
			});

		case "FilterByStoppedPickZone":
			return intl.formatMessage({
				id: "Pick Zone is stopped",
				defaultMessage: "Pick Zone is stopped",
			});

		case "FilterOutCannotProduceSingle":
			return intl.formatMessage({
				id: "Not producible as single",
				defaultMessage: "Not producible as single",
			});

		default:
			return intl.formatMessage({
				id: "Unknown",
				defaultMessage: "Unknown",
			});
	}
};
